module.exports = ".spin-center{\r\n\tmargin: 0 auto;\r\n}"